import { Action, createReducer, on } from '@ngrx/store';
import {
  categoryIsCreatedAction,
  removeRecentCategoryAction
} from 'src/app/actions/category';
import { ICategoryData } from 'src/app/shared/types/category';

export interface CategoryState {
  categories: ICategoryData[];
  recentCategory?: ICategoryData | null;
}

export const initialState: CategoryState = {
  categories: [],
  recentCategory: null
};

const _categoryReducer = createReducer(
  initialState,
  on(categoryIsCreatedAction, (state, { newCategory }) => ({
    ...state,
    categories: [...state.categories, newCategory],
    recentCategory: newCategory
  })),
  on(removeRecentCategoryAction, state => ({
    ...state,
    recentCategory: null
  }))
);

export function categoryReducer(
  state: CategoryState | undefined,
  action: Action
) {
  return _categoryReducer(state, action);
}
